import { useState } from "react";
import {
    Box,
    Tabs,
    Tab,
    Typography,
    Chip,
    Stack,
} from "@mui/material";

import FolderCard from "./FolderCard";

export default function FolderListTabs({
    tabValue,
    setTabValue,
    tabs,
}) {

    return (
        <Box sx={{ width: "100%" }}>

            {/* TABS */}
            <Tabs
                value={tabValue}
                onChange={(e, newValue) => setTabValue(newValue)}
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                    mb: 3,
                    borderBottom: "1px solid #ececec",

                    "& .MuiTab-root": {
                        textTransform: "none",
                        minHeight: 50,
                        fontWeight: 600,
                        color: "#666",
                    },

                    "& .Mui-selected": {
                        color: "#111",
                    },
                }}
            >
                {tabs.map((tab, index) => (
                    <Tab
                        key={index}
                        label={
                            <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                            >
                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: 14,
                                    }}
                                >
                                    {tab.label}
                                </Typography>

                                <Chip
                                    label={tab.data.length}
                                    size="small"
                                    sx={{
                                        height: 22,
                                        fontWeight: "bold",
                                        backgroundColor: tab.color,
                                        color: "white",
                                    }}
                                />
                            </Stack>
                        }
                    />
                ))}
            </Tabs>
        </Box>
    );
}